import { useRef, useEffect, useState } from 'react';
import SubHeader from '../header/SubHeader';
import { BASE_URL } from '../../_constant';
import CloseIcon from '@mui/icons-material/Close';
import { getAccount, watchNetwork, getNetwork } from '@wagmi/core';


export const SearchBar = ({
  className = '',
  style = {},
  onSearch,
  isOnHoverExpend = false,
}) => {
  const inputRef = useRef(null);

  // const [input, setInput] = useState(null);
  return (
    <div
      className={`search_bar shadow ${isOnHoverExpend ? 'on-hover-expand' : ''
        } ${className}`}
      style={style}
      onClick={() => {
        inputRef.current.focus();
      }}
    >
      <div
        className='search_bar_form'
        style={{
          margin: 'auto',
          //  maxWidth: 300
        }}
      >
        <div className='searc_btn'>
          <img alt='search' src='images/icon/search.svg' />
        </div>
        <input
          ref={inputRef}
          autoComplete='off'
          // value={input}
          type='text'
          placeholder='Enter token name or token symbol'
          name='search2'
          onChange={onSearch}
        />
      </div>
    </div>
  );
};

const SaleLayout = ({
  // title,
  renderFilter,
  tabs = [],
  activeTab,
  onTabClick,
  children,
  // toggleFilter,
  renderSearch,
}) => {

  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false); // Track animation state
  const account = getAccount();
  console.log("account>>>>>>>>>>>", account.isConnected)

  console.log("isVisible>>>>>>", isVisible)
  const toggleDiv = () => {
    setIsVisible(!isVisible);
  };


  function getLabelById(id) {
    const tab = tabs.find((tab) => tab?.id === activeTab);
    return tab ? tab.label : null; // Returns the label or null if not found
  }
  const [title, setTitle] = useState('')

  useEffect(() => {
    setTitle(getLabelById(activeTab))
  }, [activeTab])

  // Dynamically filter the tabs
  const filteredTabs = tabs.filter((tab) => {
    if (['my_created_presale', 'myalarms', 'my_contribution'].includes(tab.id)) {
      return account.isConnected; // Show these tabs only when the account is connected
    }
    return true; // Show all other tabs by default
  });
  function getLabelById(id) {
    const tab = filteredTabs.find((tab) => tab?.id === id);
    return tab ? tab.label : null; // Returns the label or null if not found
  }


  return (
    <div className='d-flex gap-3 gap-md-4 slide-container'>
      {/* left - content */}
      <div className='w-100'>
        {/* header */}

        <div className='d-block d-md-flex gap-2 flex-wrap align-items-center justify-content-between mb-3'>
          <div className='mb-3 m-md-0'>
            <SubHeader title={title} marginBottom={0} />
          </div>
          <div className='d-flex align-items-center justify-content-end gap-2 gap-sm-3 flex-grow-1 mb-3 mb-md-0'>
            {renderSearch && renderSearch}
            {renderFilter && (
              <>
                {/* <div
                  className='text-white d-flex align-items-center gap-2 pointer d-xl-none'
                  onClick={toggleFilter}
                  style={{
                    height: 'fit-content',
                  }}
                  // data-bs-toggle='offcanvas'
                  // data-bs-target='#offcanvasWithBothOptions'
                  // aria-controls='offcanvasWithBothOptions'
                >
                  <i className='fa fa-filter icon'></i>
                  Filters
                </div> */}
                <button
                  className='btn-filter btn btn-primary d-none align-items-center gap-2 d-xxl-none'
                  type='button'
                  data-bs-toggle='offcanvas'
                  data-bs-target='#offcanvasWithBothOptions'
                  aria-controls='offcanvasWithBothOptions'
                >
                  <i className='fa fa-filter icon'></i>{' '}
                  <span className='d-none d-sm-inline'>Filters</span>
                </button>
                {/* <li className='nav-item ms-auto'>
              <button
                className='text-nowrap nav-link d-none d-lg-block filter_button'
                onClick={toggleDiv}
              >
                <i className='fa fa-filter icon'></i>{' '}
              </button>
            </li> */}
                <button
                  className='filter_button btn btn-primary d-none align-items-center gap-2 d-lg-block'
                  type='button'
                  onClick={toggleDiv}
                >
                  <i className='fa fa-filter icon'></i>{' '}
                  <span className='d-sm-inline'>Filters</span>
                </button>
              </>
            )}

            <div
              className='offcanvas offcanvas-start bg-secondary'
              style={{
                width: '300px',
              }}
              data-bs-scroll='true'
              tabindex='-1'
              id='offcanvasWithBothOptions'
              aria-labelledby='offcanvasWithBothOptionsLabel'
            >
              <div className='offcanvas-header'>
                <h5
                  className='offcanvas-title text-white'
                  id='offcanvasWithBothOptionsLabel'
                >
                  Filters
                </h5>
                <button
                  type='button'
                  className='btn-close btn-close-white'
                  data-bs-dismiss='offcanvas'
                  aria-label='Close'
                ></button>
              </div>
              <div className='offcanvas-body px-0'>{renderFilter}</div>
            </div>
          </div>
        </div>
        {/* tabs */}
        <div className='presales_tabs'>
          <ul className='position-relative nav nav-tabs w-100 flex-nowrap overflow-auto overflow-y-hidden mb-1 mb-lg-0 presales_tabs_scroll'>
            {/* {tabs.map((tab, index) => {
              return (
                <li key={index} className='nav-item'>
                  <button
                    className={`nav-link text-nowrap ${activeTab === tab.id && 'active'}`}
                    data-bs-toggle='tab'
                    href={tab.href}
                    onClick={() => {
                      onTabClick(tab.id);
                    }}
                  >
                    {tab?.icon ? <img src={tab?.icon} width={20} /> : tab.label}
                  </button>
                </li>
              );
            })} */}

            {filteredTabs.map((tab, index) => (
              <li key={index} className="nav-item">
                <button
                  className={`nav-link text-nowrap ${activeTab === tab.id && 'active'}`}
                  onClick={() => onTabClick(tab.id)}
                >
                  {tab?.icon ? <img src={tab?.icon} width={20} alt={tab.label} /> : tab.label}
                </button>
              </li>
            ))}
            {/* <li className='nav-item ms-auto'>
              <button
                className='text-nowrap nav-link d-none d-lg-block filter_button'
                onClick={toggleDiv}
              >
                <i className='fa fa-filter icon'></i>{' '}
              </button>
            </li> */}
          </ul>
        </div>

        <div className='my-4'>{children}</div>
      </div>
      {/* <div className="slide-container"> */}
      <div
        className={`slide-div ${isVisible ? "show" : "hidden"} h-100`}

      >
        {renderFilter && (
          <div className='filter-container h-100 card pb-5 px-0 py-4 h_max_content' style={{ border: "2px solid var(--clr-searchbar-border)" }}>

            <div className='px-4 d-flex justify-content-between align-items-start'>
              <h6
                className='text-muted fw-normal fs-6 mb-4 '
              >
                Filters
              </h6>
              <CloseIcon onClick={toggleDiv} className="hover_cross" /> {' '}
            </div>
            {renderFilter}
          </div>
        )}
      </div>
      {/* </div> */}
      {/* right - filter */}
      {/* {renderFilter && (
        <div className='filter-container card px-0 py-4'>
       
          <div className='px-4 d-flex justify-content-between align-items-start'>
            <h6
              className='text-muted fw-normal fs-6 mb-4 '
            >
              Filters
            </h6>
          </div>
          {renderFilter}
        </div>
      )} */}
    </div>
  );
};

export default SaleLayout;
